module.exports = __webpack_public_path__ + "static/media/huie.b18fe15e.jpg";